export const MERGER_ARBITRAGE = "100011";